/**
 * Terroirs map: a province, its pill or an address naming it opens that one
 * plate. Each plate watermark is a <use> of the path the map draws, so all this
 * adds is the view box that crops it and the size of the numbered marks.
 */
(function () {
  'use strict';
  const bq = window.bq;
  if (!bq) return;

  // Share of the frame a framed province takes, and the bounds it is held
  // between. The cap is low so the neighbours stay in frame and clickable.
  const CADRE = { part: 0.5, min: 1.35, max: 3.4 };

  // Air around a watermark outline, as a share of its longer side.
  const MARGE = 0.06;

  // Drawn size of a mark and its number, in pixels.
  const MARQUE = { r: 4.6, texte: 6.4 };

  const ANCRE = '#terroir-';

  // Below this width the column sits over the plates instead of beside them.
  const compact = window.matchMedia('(max-width: 989px)');

  function doux() {
    return bq.reducedMotion() ? 'auto' : 'smooth';
  }

  function init(scene) {
    if (scene.dataset.bqTerroirsInit) return;
    scene.dataset.bqTerroirsInit = '1';

    const svg = scene.querySelector('.bq-carte-cn');
    const zoom = scene.querySelector('[data-bq-carte-zoom]');
    if (!svg || !zoom || !svg.viewBox) return;
    const frame = svg.viewBox.baseVal;

    const boussole = scene.querySelector('[data-bq-terroirs-boussole]');
    const repos = boussole ? boussole.textContent : '';
    const entier = scene.querySelector('[data-bq-entier]');
    const accueil = scene.querySelector('[data-bq-accueil]');
    const index = scene.querySelector('.bq-terroirs__index');

    // Null prototype: a slug read from a table must never reach Object.
    const formes = Object.create(null);
    const planches = Object.create(null);
    const pastilles = Object.create(null);
    const cartes = Object.create(null);
    const ordre = [];

    svg.querySelectorAll('[data-p]').forEach(function (el) {
      formes[el.dataset.p] = el;
    });
    scene.querySelectorAll('[data-bq-planche]').forEach(function (el) {
      planches[el.dataset.bqPlanche] = el;
      ordre.push(el.dataset.bqPlanche);
    });
    scene.querySelectorAll('[data-bq-p]').forEach(function (el) {
      pastilles[el.dataset.bqP] = el;
    });
    // A plant is written once, on the first plate naming it; later plates carry a
    // stub, filled from that card when the plate opens.
    scene.querySelectorAll('[data-bq-card]').forEach(function (el) {
      cartes[el.dataset.bqCard] = el;
    });
    if (!ordre.length) return;

    let lu = '';
    let survol = '';

    // Centre the province in the frame. The group origin is the view box origin,
    // so the move is one scale and one translation in view box units.
    function cadre(slug) {
      const el = formes[slug];
      if (!el) return null;
      const b = el.getBBox();
      if (!b.width || !b.height) return null;
      const fit = Math.min(frame.width / b.width, frame.height / b.height) * CADRE.part;
      const s = Math.min(Math.max(fit, CADRE.min), CADRE.max);
      return {
        s: s,
        x: frame.width / 2 - s * (b.x + b.width / 2),
        y: frame.height / 2 - s * (b.y + b.height / 2),
      };
    }

    // The compass names the province under the pointer, else the one being read,
    // else the country.
    function ecrit() {
      if (!boussole) return;
      const slug = survol || lu;
      const art = slug ? planches[slug] : null;
      boussole.textContent = art ? art.dataset.bqBoussole : repos;
    }

    // Order is kept: a stub is filled where it stands.
    function garnit(planche, tout) {
      planche.querySelectorAll('[data-bq-clone]').forEach(function (stub) {
        if (!tout && stub.hidden) return;
        const source = cartes[stub.dataset.bqClone];
        if (!source) return;
        const copie = source.cloneNode(true);
        stub.textContent = '';
        while (copie.firstChild) stub.appendChild(copie.firstChild);
        stub.className = source.className;
        stub.removeAttribute('data-bq-clone');
      });
    }

    // The watermark is cropped to the outline the map draws, so the view box is
    // read from the map itself, the same reading sizing the marks.
    function trace(planche) {
      if (!planche) return;
      planche.querySelectorAll('[data-bq-trace]').forEach(function (dessin) {
        const el = formes[dessin.dataset.bqTrace];
        if (!el) return;
        const b = el.getBBox();
        if (!b.width || !b.height) return;
        const m = Math.max(b.width, b.height) * MARGE;
        const w = b.width + m * 2;
        const h = b.height + m * 2;
        dessin.setAttribute('viewBox', b.x - m + ' ' + (b.y - m) + ' ' + w + ' ' + h);

        const box = dessin.getBoundingClientRect();
        if (!box.width) return;
        const echelle = Math.min(box.width / w, box.height / h);
        const r = (MARQUE.r / echelle).toFixed(2);
        const t = (MARQUE.texte / echelle).toFixed(2);
        dessin.querySelectorAll('circle').forEach(function (c) {
          c.setAttribute('r', r);
        });
        dessin.querySelectorAll('text').forEach(function (c) {
          c.setAttribute('font-size', t);
        });
      });
    }

    // Below 990px the map sits over the text, so the plate is scrolled to; above,
    // the column is sticky and only a reader carried past the stage needs it back.
    function va(planche) {
      if (compact.matches) {
        planche.scrollIntoView({ block: 'start', behavior: doux() });
        return;
      }
      remonte();
    }

    // Horizon scrolls .page-wrapper from 990px up: scrollTo on the real scroller,
    // scrollIntoView being dropped when the page shortens in the same frame.
    function defileur() {
      const pw = document.querySelector('.page-wrapper');
      if (pw && /auto|scroll/.test(getComputedStyle(pw).overflowY)) return pw;
      return null;
    }

    // Bring the top of the stage back in view, wherever the page stood: the
    // whole-map button is often pressed from the foot of a plate.
    function remonte() {
      const haut = parseFloat(getComputedStyle(scene).getPropertyValue('--bqt-haut')) || 0;
      const top = scene.getBoundingClientRect().top;
      if (top >= haut) return;
      const pw = defileur();
      const b = doux();
      if (pw) pw.scrollTo({ top: pw.scrollTop + top - haut, behavior: b });
      else window.scrollTo({ top: window.scrollY + top - haut, behavior: b });
    }

    // One province at a time; map, pills and compass follow. An empty slug means
    // the whole country.
    function ouvre(slug, options) {
      // A section reloaded in the editor leaves the old stage detached with its
      // key and address listeners behind: they must not answer for it.
      if (!scene.isConnected) return;
      const o = options || {};
      const cible = planches[slug] ? slug : '';
      const art = cible ? planches[cible] : null;
      lu = cible;

      if (art) garnit(art, false);
      Object.keys(planches).forEach(function (k) {
        planches[k].hidden = k !== cible;
        planches[k].classList.toggle('is-lu', k === cible);
      });
      if (accueil) accueil.hidden = cible !== '';

      Object.keys(formes).forEach(function (k) {
        formes[k].classList.toggle('is-lu', k === cible);
      });
      scene.classList.toggle('is-lue', cible !== '');

      Object.keys(pastilles).forEach(function (k) {
        pastilles[k].classList.toggle('is-lu', k === cible);
        pastilles[k].setAttribute('aria-pressed', k === cible ? 'true' : 'false');
      });
      if (entier) entier.hidden = cible === '';

      // Below 990px the index scrolls sideways, so bring the current pill back
      // into it however the plate was opened.
      const lue = cible ? pastilles[cible] : null;
      if (lue && index && index.scrollWidth > index.clientWidth) {
        const gauche =
          index.scrollLeft + lue.getBoundingClientRect().left - index.getBoundingClientRect().left - 16;
        index.scrollTo({ left: Math.max(0, gauche), behavior: doux() });
      }

      const c = cible ? cadre(cible) : null;
      if (c) {
        zoom.style.setProperty('--zx', c.x.toFixed(2) + 'px');
        zoom.style.setProperty('--zy', c.y.toFixed(2) + 'px');
        zoom.style.setProperty('--zs', c.s.toFixed(4));
      } else {
        zoom.style.removeProperty('--zx');
        zoom.style.removeProperty('--zy');
        zoom.style.removeProperty('--zs');
      }

      // The plate was display:none a moment ago: its box is zero until layout,
      // and the marks are sized from that box.
      if (art) {
        window.requestAnimationFrame(function () {
          trace(art);
        });
      }

      ecrit();

      if (o.histoire !== false) {
        const url = cible ? ANCRE + cible : location.pathname + location.search;
        history.replaceState(null, '', url);
      }
      if (o.defile) {
        if (art) va(art);
        else remonte();
      }
    }

    // A hover only colours and names a province: reframing under the pointer
    // moves the target out from under the reader aiming at it.
    function survole(slug) {
      const next = formes[slug] ? slug : '';
      if (survol === next) return;
      survol = next;
      Object.keys(formes).forEach(function (k) {
        formes[k].classList.toggle('is-survol', k === next);
      });
      ecrit();
    }

    // The fold: plants past the eighth and the link that unfolds them. Focus
    // follows the first one out so the keyboard lands where the reading resumes.
    function deplie(bouton) {
      const planche = bouton.closest('[data-bq-planche]');
      if (!planche) return;
      garnit(planche, true);
      const caches = planche.querySelectorAll('.bq-terroirs__plantes > [hidden]');
      caches.forEach(function (li) {
        li.hidden = false;
      });
      const premier = caches.length ? caches[0].querySelector('a') : null;
      bouton.remove();
      if (premier) premier.focus();
    }

    scene.addEventListener('pointerover', function (e) {
      if (e.pointerType === 'touch' || !e.target.closest) return;
      const hit = e.target.closest('[data-p], [data-bq-p]');
      survole(hit ? hit.dataset.p || hit.dataset.bqP : '');
    });

    scene.addEventListener('pointerleave', function () {
      survole('');
    });

    scene.addEventListener('focusin', function (e) {
      if (!e.target.closest) return;
      const hit = e.target.closest('[data-bq-p]');
      survole(hit ? hit.dataset.bqP : '');
    });

    scene.addEventListener('focusout', function (e) {
      const next = e.relatedTarget;
      if (next && next.closest && next.closest('[data-bq-p]')) return;
      survole('');
    });

    scene.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      const plus = e.target.closest('[data-bq-plus]');
      if (plus) {
        deplie(plus);
        return;
      }
      if (e.target.closest('[data-bq-entier]')) {
        ouvre('', { defile: true });
        return;
      }
      const hit = e.target.closest('[data-p], [data-bq-p]');
      if (!hit) return;
      // A province the catalogue has nothing on has no plate, so no answer.
      const slug = hit.dataset.p || hit.dataset.bqP;
      if (planches[slug]) ouvre(slug, { defile: true });
    });

    // Escape gives the country back, unless a dialog is holding the key.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !lu) return;
      if (document.querySelector('dialog[open]')) return;
      ouvre('', { defile: true });
    });

    // The slug the address names, when it names a plate.
    function adresse() {
      const h = location.hash;
      const slug = h.indexOf(ANCRE) === 0 ? h.slice(ANCRE.length) : '';
      return planches[slug] ? slug : '';
    }

    // The address moved on its own: follow it without writing it back.
    function suit() {
      const slug = adresse();
      ouvre(slug, { defile: slug !== '', histoire: false });
    }

    window.addEventListener('popstate', suit);
    window.addEventListener('hashchange', suit);

    // Only the plate on show is measured; the others are measured when opened.
    function remesure() {
      if (lu) trace(planches[lu]);
    }

    const depart = adresse();
    ouvre(depart, { defile: depart !== '', histoire: false });

    if ('ResizeObserver' in window) new ResizeObserver(remesure).observe(scene);
    else window.addEventListener('resize', remesure);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(remesure).catch(function () {
        // A font that never settles leaves the marks at the size measured now.
      });
    }
  }

  document.querySelectorAll('[data-bq-terroirs]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-bq-terroirs]').forEach(init);
  });
})();
